import { render, staticRenderFns } from "./brand-logo.vue?vue&type=template&id=acaf8114&scoped=true"
import script from "./brand-logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./brand-logo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./brand-logo.vue?vue&type=style&index=0&id=acaf8114&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaf8114",
  null
  
)

export default component.exports